import React, {useEffect, useState} from "react";
import {useParams, useNavigate} from "react-router-dom";
import apiRequests from "../../../Component/axios/config/config";
import Loading from "../../../Component/Loading/Loading";
import {Pencil, Eye, EyeOff, Upload} from "lucide-react";
import {MdArrowBack} from "react-icons/md";
import Dropdown from "../../../Component/Dropdown/Drowdown";
import toast from "react-hot-toast";
import {FaTimes} from "react-icons/fa";


export default function AdminProductDetails() {

    const {id} = useParams();
    const navigate = useNavigate();

    const [product, setProduct] = useState(null);

    const [loading, setLoading] = useState(true);
    const [loadingImage, setLoadingImage] = useState(false);
    const [loadingEdit, setLoadingEdit] = useState(false);
    const [loadingCategory, setLoadingCategory] = useState(false);

    const [showModalCategory, setShowModalCategory] = useState(false);
    const [CategoryListData, setCategoryListData] = useState([])

    const [name, setName] = useState({
        en: "",
        fa: "",
        fr: "",
        de: "",
        zh: "",
    });
    const [Stock, setStock] = useState(0);
    const [description, setDescription] = React.useState({
        en: "",
        fa: "",
        fr: "",
        de: "",
        zh: "",
    });

    const [Price, setPrice] = useState(0);
    const [Category, setCategory] = useState({
        id: "",
        name: ""
    });


    const [imageUrl, setImageUrl] = useState([]);
    const [imageID, setImageID] = useState([]);
    const [attributes, setAttributes] = useState({})


    useEffect(() => {
        fetchProduct()
    }, [id]);

    useEffect(() => {
        if (!Category.id) return;

        setAttributes({});
        fetchCategoryData(Category.id);
    }, [Category.id]);

    useEffect(() => {

        apiRequests.get("api/category/get-all-admin")
            .then((res) => {
                setCategoryListData(res.data.data)
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
            })
            .finally(() => {
            });

    }, []);

    const fetchProduct = async () => {

        setLoading(true);
        apiRequests.get(`/api/product/get-single/${id}`)
            .then((response) => {
                const data = response.data.data;

                setProduct(data);
                setName({
                    en: data?.name?.en || "",
                    fa: data?.name?.fa || "",
                    fr: data?.name?.fr || "",
                    de: data?.name?.de || "",
                    zh: data?.name?.zh || "",
                });
                setDescription({
                    en: data.description?.en || "",
                    fa: data.description?.fa || "",
                    fr: data.description?.fr || "",
                    de: data.description?.de || "",
                    zh: data.description?.zh || "",
                });
                setCategory({
                    id: data?.category?._id,
                    name: data?.category?.name
                });
                setStock(data.stock);
                setPrice(data.price);
                setImageUrl(data?.images);
                const imageIDs = data.images.map(item => item._id);
                setImageID(imageIDs);

            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
            })
            .finally(() => setLoading(false));

    };

    function readImage() {
        document.querySelector('#profile')?.click();
    }

    function UploadImage(e) {

        const formData = new FormData();
        formData.append('file', e.target.files[0]);

        setLoadingImage(true)
        apiRequests.post(`/api/file/v1/upload-admin`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then((response) => {
            setImageUrl([...imageUrl, response.data.message]);
            setImageID([...imageID, response.data.message._id])
        }).catch((error) => {
            if (error.status === 401 || error.status === 403) {
                navigate("/login");
            }
        }).finally(() => {
            setLoadingImage(false)
        })
    }


    function EditProduct() {

        if (name.fa === "" || name.en === "" || name.fr === "" || name.de === "" || name.zh === "" || description.fa === "" || description.fr === "" || description.de === "" || description.zh === "" || description.en === "") {
            toast.error("Please enter all fields for name and description");
            return;
        }

        const data = {

            productId: id,
            name: name,
            price: Price,
            description: description,
            images: imageID,
            category: Category.id,
            stock: Stock,

        }

        setLoadingEdit(true)
        apiRequests.patch(`/api/product/update-admin`, data)
            .then(() => {
                toast.success("successfully updated product!")
                setImageID([])
                setImageUrl([])
                fetchProduct()
                navigate("/my-product")
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
                toast.error("error updating product!")
            })
            .finally(() => setLoadingEdit(false));

    }

    if (loading) return <div className="p-12"><Loading/></div>;
    if (!product) return <div className="text-center font-bold text-xl text-gray-500 mt-20">Product not found</div>;

    function removeImage(imageToRemove) {
        setImageUrl((prev) => prev.filter((img) => img._id !== imageToRemove._id));
        setImageID((prev) => prev.filter((id) => id !== imageToRemove._id));
    }

    function fetchCategoryData(categoryId) {
        setLoadingCategory(true);
        apiRequests.get(`/api/category/get-single/${categoryId}`)
            .then((response) => {
                setAttributes(response.data.data.specifications);
            })
            .finally(() => setLoadingCategory(false));
    }


    return (


        <div className="max-w-6xl mx-auto">

            <div className="flex flex-col sm:flex-row mt-8 justify-between gap-4">
                <div className="flex gap-2">
                    <button
                        onClick={EditProduct}
                        className="flex items-center bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg gap-2"
                    >
                        {loadingEdit ?
                            <Loading textColor={"white-0"}/>
                            :
                            <>
                                <Pencil className="w-4 h-4"/>
                                Edit Product
                            </>
                        }

                    </button>
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center justify-center border-2 hover:bg-black hover:text-white border-black text-baseColor-first px-4 py-2 rounded-lg gap-2"
                    >
                        <MdArrowBack/>
                        Back
                    </button>
                </div>
            </div>


            <div className="bg-white p-6">


                <div className="flex flex-col gap-8">

                    <div className="mt-6">
                        <label className="block mb-2 font-medium">Product Images *</label>
                        <div className="flex flex-wrap gap-4">
                            {imageUrl.length > 0 && (
                                imageUrl.map((img, index) => {
                                    return (
                                        <div key={index} className="relative group">
                                            <img
                                                src={`https://api.goalafarin.com/${img.path}`}
                                                alt="Preview"
                                                className="w-32 h-32 object-cover rounded-lg border"
                                            />

                                            <button
                                                type="button"
                                                onClick={() => removeImage(img)}
                                                className="absolute top-2 right-2 bg-white/80 p-1 rounded-full hover:bg-red-100"
                                            >
                                                <FaTimes className="w-4 h-4 text-red-600"/>
                                            </button>

                                        </div>
                                    )
                                })
                            )}
                            <label
                                className="w-32 h-32 border-2 border-dashed rounded-lg flex items-center justify-center cursor-pointer hover:border-indigo-500">
                                {!loadingImage &&
                                    <input
                                        type="file" accept="image/*"
                                        onClick={() => readImage()}
                                        onChange={UploadImage}
                                        className="hidden"
                                    />
                                }

                                <div className="text-center text-gray-500">
                                    {loadingImage ?

                                        <div className="mx-auto mb-2">
                                            <svg aria-hidden="true"
                                                 className="inline w-5 h-5 text-white animate-spin dark:text-gray-600 fill-white"
                                                 viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="currentColor"/>
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentFill"/>
                                            </svg>
                                        </div>
                                        :
                                        <Upload className="mx-auto mb-2"/>
                                    }

                                    <span>
                                        {loadingImage ?
                                            "Uploading..."
                                            :
                                            "Upload Images"
                                        }

                                    </span>
                                </div>
                            </label>
                        </div>
                    </div>


                    <div className="p-4 flex flex-col rounded-xl gap-2 border border-gray-200 bg-gray-100">


                        <div className="grid grid-cols-2 auto-cols-auto gap-5">

                            <h2 className="text-firstColor-shade9 text-2xl font-bold">Name</h2>
                            <h2 className="text-firstColor-shade9 text-2xl font-bold">Information</h2>

                            <div className="border rounded-xl p-4 flex flex-col gap-3 md:col-span-2">

                                <DetailItem label="Persian Name">
                                    <input
                                        placeholder="Enter Persian Name"
                                        className="py-1 pl-2 bg-transparent outline-none w-full border rounded-lg border-black text-gray-900"
                                        value={name.fa}
                                        onChange={(e) => setName({...name, fa: e.target.value})}/>
                                </DetailItem>

                                <DetailItem label="German Name">
                                    <input
                                        placeholder="Enter German Name"
                                        className="py-1 pl-2 bg-transparent outline-none w-full border rounded-lg border-black text-gray-900"
                                        value={name.de}
                                        onChange={(e) => setName({...name, de: e.target.value})}/>
                                </DetailItem>

                                <DetailItem label="English Name">
                                    <input
                                        placeholder="Enter English Name"
                                        className="py-1 pl-2 bg-transparent outline-none w-full border rounded-lg border-black text-gray-900"
                                        value={name.en}
                                        onChange={(e) => setName({...name, en: e.target.value})}/>
                                </DetailItem>

                                <DetailItem label="French Name">
                                    <input
                                        placeholder="Enter French Name"
                                        className="py-1 pl-2 bg-transparent outline-none w-full border rounded-lg border-black text-gray-900"
                                        value={name.fr}
                                        onChange={(e) => setName({...name, fr: e.target.value})}/>
                                </DetailItem>

                                <DetailItem label="Chinese Name">
                                    <input
                                        placeholder="Enter Chinese Name"
                                        className="py-1 pl-2 bg-transparent outline-none w-full border rounded-lg border-black text-gray-900"
                                        value={name.zh}
                                        onChange={(e) => setName({...name, zh: e.target.value})}/>
                                </DetailItem>
                            </div>


                            <div className="border rounded-xl p-4 flex flex-col gap-3 md:col-span-2">

                                <DetailItem label="Stock">
                                    <div className="flex items-center">
                                        <input
                                            className="py-1 pl-2 bg-transparent outline-none w-full border rounded-lg border-black text-gray-900"
                                            type="number"
                                            value={Stock}
                                            onChange={(e) => setStock(parseInt(e.target.value))}/>
                                    </div>
                                </DetailItem>


                                <DetailItem label="Price">
                                    <div
                                        className="flex items-center border rounded-lg border-black text-gray-900 pl-3">
                                        €
                                        <input
                                            className="py-1 pl-2 bg-transparent outline-none w-full"
                                            type="number"
                                            step="0.01"
                                            value={Price}
                                            onChange={(e) => setPrice(parseFloat(e.target.value) || "")}
                                        />
                                    </div>
                                </DetailItem>


                                <DetailItem label="Category">
                                    <div className="inline-block relative w-full"
                                         onClick={() => setShowModalCategory(!showModalCategory)}>

                                        <input
                                            className="py-1 pl-2 bg-transparent outline-none w-full border rounded-lg border-black text-gray-900"
                                            value={Category.name}
                                            readOnly
                                            placeholder="enter category"/>

                                        {showModalCategory &&
                                            <Dropdown data={CategoryListData} setOpen={setShowModalCategory}
                                                      setValue={setCategory}/>}

                                    </div>
                                </DetailItem>

                                <DetailItem label="Attributes">
                                    {loadingCategory ? (
                                        <div>
                                            <Loading />
                                        </div>
                                    ) : (
                                        attributes && Object.keys(attributes).length > 0 &&
                                        Object.entries(attributes).map(([key, value]) => (
                                            <div className="flex items-center gap-6" key={key}>
                                                <div className="text-gray-900 py-2 text-left font-bold">{key}:</div>
                                                <div
                                                    className="text-lg px-4 py-2 text-grey-shade10 lg:text-right">{value || "-"}</div>
                                            </div>
                                        ))
                                    )}
                                </DetailItem>
                            </div>

                        </div>

                    </div>

                    <div className="p-4 flex flex-col rounded-xl gap-6 border border-gray-200 bg-gray-100">
                        <h3 className="text-firstColor-shade9 text-2xl font-bold">Descriptions</h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block mb-2 font-medium">Description (Persian)</label>
                                <textarea
                                    className="w-full resize-none p-2 outline-none bg-transparent border rounded-lg border-black text-gray-900"
                                    value={description.fa}
                                    onChange={e => setDescription({...description, fa: e.target.value})}
                                    rows={3}
                                    placeholder="توضیحات فارسی را وارد کنید"
                                />
                            </div>

                            <div>
                                <label className="block mb-2 font-medium">Description (German)</label>
                                <textarea
                                    className="w-full resize-none p-2 outline-none bg-transparent border rounded-lg border-black text-gray-900"
                                    value={description.de}
                                    onChange={e => setDescription({...description, de: e.target.value})}
                                    rows={3}
                                    placeholder="Geben Sie die Beschreibung auf Deutsch ein"
                                />
                            </div>

                            <div>
                                <label className="block mb-2 font-medium">Description (English)</label>
                                <textarea
                                    className="w-full resize-none p-2 outline-none bg-transparent border rounded-lg border-black text-gray-900"
                                    value={description.en}
                                    onChange={e => setDescription({...description, en: e.target.value})}
                                    rows={3}
                                    placeholder="Enter English description"
                                />
                            </div>


                            <div>
                                <label className="block mb-2 font-medium">Description (French)</label>
                                <textarea
                                    className="w-full resize-none p-2 outline-none bg-transparent border rounded-lg border-black text-gray-900"
                                    value={description.fr}
                                    onChange={e => setDescription({...description, fr: e.target.value})}
                                    rows={3}
                                    placeholder="Entrez la description en français"
                                />
                            </div>


                            <div>
                                <label className="block mb-2 font-medium">Description (Chinese)</label>
                                <textarea
                                    className="w-full resize-none p-2 outline-none bg-transparent border rounded-lg border-black text-gray-900"
                                    value={description.zh}
                                    onChange={e => setDescription({...description, zh: e.target.value})}
                                    rows={3}
                                    placeholder="输入中文描述"
                                />
                            </div>
                        </div>
                    </div>


                    <div className="p-4 flex flex-col rounded-xl gap-2 border border-gray-200 bg-gray-100">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                            <div className="p-3 rounded-lg">
                                <span className="text-gray-500">Created At</span>
                                <p className="font-medium">
                                    {new Date(product.createdAt).toLocaleDateString('en-US', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    })}
                                </p>
                            </div>
                            <div className="p-3 rounded-lg">
                                <span className="text-gray-500">Last Updated</span>
                                <p className="font-medium">
                                    {new Date(product.updatedAt).toLocaleDateString('en-US', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    })}
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}


const DetailItem = ({label, children}) => (
    <div className="flex flex-col gap-3 py-2 px-3 rounded-lg">
        <span className="text-gray-900">{label} :</span>
        <div className="text-gray-500">{children}</div>
    </div>
);